import { RouteRecordRaw } from '@bv/router';

export const profileRoutes: RouteRecordRaw = {
  path: '/personal-settings',
  name: 'profile',
  redirect: { name: 'personal-settings-view' },
  meta: {
    header: { title: 'GLOBAL.PROFILE_SETTINGS', icon: 'bvi-setting' },
    breadcrumbs: [
      {
        label: 'GLOBAL.PROFILE_SETTINGS',
        route: { name: 'profile' },
      },
    ],
  },
  component: () => import('@/views/Main/PersonalSettings/PersonalSettingsView.vue'),
  children: [
    {
      path: '',
      name: 'personal-settings-view',
      component: () => import('@/views/Main/PersonalSettings/PersonalSettings.vue'),
    },
    {
      path: 'edit',
      name: 'edit-personal-settings',
      component: () => import('@/views/Main/PersonalSettings/EditPersonalSettings.vue'),
    },
  ],
};
